module.exports = __webpack_public_path__ + "static/021.thumb-76893234fed597a339181796cc2cf1b6.jpg";